// extracted by mini-css-extract-plugin
module.exports = {"heading":"Support_heading__O1ZsB","searchContainer":"Support_searchContainer__3Vty5","markdown":"Support_markdown__2OSAV"};